import React, { useState, useEffect } from 'react';

import Button from "react-bootstrap/Button";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { SignOutButton } from './office365auth/SignOutButton';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { getMsToken, getStudentMetadata } from '../helper/studentMetadata'
import { isUserFromApp } from '../api/index';

export default function AliatNavBar() {
    const expand = "xxxxl";
    const [showLeftMenu, setShowLeftMenu] = useState(false);
    const [showRightMenu, setShowRightMenu] = useState(false);
    const [performSignOut, setPerformSignOut] = useState(false);

    const handleClose = () => { setShowLeftMenu(false); setShowRightMenu(false) };
    const handleShowLeftMenu = () => setShowLeftMenu(true);
    const handleShowRightMenu = () => setShowRightMenu(true);

    const [studentMetadata, setStudentMetadata] = useState(null);

    let isAuthenticated = useIsAuthenticated();
    const [authenticated, setAuthenticated] = useState(isAuthenticated);

    useEffect(() => {
        if (isUserFromApp()) {
            setAuthenticated(true);
        }
    }, []);

    useEffect(() => {
        window.addEventListener("populateStudentMetadata", (e) => { setStudentMetadata(e.detail) });
    }, []);

    const OffcanvasLeft = () => {
        return (<>
            <Button variant="primary" onClick={handleShowLeftMenu} className="offcanvas-button">
                <span className="material-symbols-outlined">
                    menu
                </span>
            </Button>

            <Offcanvas show={showLeftMenu} onHide={handleClose} className="portal-offcanvas" >
                <Offcanvas.Header closeButton style={{ backgroundColor: "#20325F", color: "var(--white)" }} onClick={handleClose}>
                    <Offcanvas.Title>Cerrar</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ backgroundColor: "#20325F", color: "var(--white)" }}>
                    <Nav className="justify-content-end flex-grow-1 pe-3">
                        <Nav.Link href="./">
                            Inicio
                        </Nav.Link>
                        <Nav.Link href="acerca">
                            Acerca
                        </Nav.Link>
                        <Nav.Link href="contactanos">
                            Contáctanos
                        </Nav.Link>
                        <Nav.Link href="descarga">
                            Descarga Mi Red Aliat
                        </Nav.Link>
                        <hr />
                        <Nav.Link className="cerrar-sesion" onClick={() => { setPerformSignOut(true) }}>
                            <div>
                            Cerrar Sesión
                            </div>
                            <div>
                                <span style={{ transform: "rotate(180deg)" }} className="material-symbols-outlined">logout</span>
                            </div>
                        </Nav.Link>
                    </Nav>
                </Offcanvas.Body>
                
            </Offcanvas>
        </>);
    };

    const OffcanvasRight = () => {
        const [studentMetadata, setStudentMetadata] = useState(null);
        const validStudent = studentMetadata?.matricula != null;

        useEffect(() => {
            const storedStudentMetadata = getStudentMetadata();
            if (!studentMetadata) setStudentMetadata(storedStudentMetadata);
            if (studentMetadata?.matricula !== storedStudentMetadata?.matricula) setStudentMetadata(storedStudentMetadata);
        });

        if (!validStudent) return null;

        return (<>
            <DropdownButton onClick={() => { setStudentMetadata(getStudentMetadata()); }} className="dropdown-student-info" id="dropdown-basic-button" align="end" autoClose="outside"
                title={<span className="material-symbols-outlined">account_circle</span>}>

                {studentMetadata &&
                    <div className="student-info" style={{ width: "20em", padding: "10px" }}>
                        <div className="mb-2">
                            <div>Estudiante</div>
                            <strong>{studentMetadata.nombre}</strong>
                        </div>
                        <hr />
                        <div className="mb-2">
                            <div>Matrícula</div>
                            <strong>{studentMetadata.matricula}</strong>
                        </div>
                        <hr />
                        <div className="mb-2">
                            <div>Campus</div>
                            <strong>{studentMetadata.descrcampus}</strong>
                        </div>
                        <hr />
                        <div className="mb-4">
                            <div>Plan activo</div>
                            <strong>{studentMetadata.planActivo}</strong>
                        </div>

                        {studentMetadata && studentMetadata.planCount > 1 && (
                            <div className="d-grid mt-4">
                                <Button variant="primary" onClick={() => { window.location.reload() }}>Cambiar Plan</Button>
                            </div>
                        )}
                    </div>
                }
            </DropdownButton>

            {performSignOut && <SignOutButton performSignOut={performSignOut} />}
        </>);
    };

    return (<>
        <Navbar key={expand} expand={expand} className="bg-body-tertiary">
            <OffcanvasLeft />
            <OffcanvasRight />
        </Navbar>
    </>);
}

